import { store } from '@/state/store';
import { local_workspace_transfer_ownership_proposal_delete } from '@/state/workspace/ownership/local_workspace_transfer_ownership_proposal_delete';
import { local_workspace_transfer_ownership_proposal_upsert } from '@/state/workspace/ownership/local_workspace_transfer_ownership_proposal_upsert';
import { DTOWorkspaceTranserOwnershipProposal } from '@shared/dto/+workspace/workspace_transfer_ownership_proposal/dto_workspace_transfer_ownership_proposal';
import { ENUM__network_event_server_to_client as ENE } from '@shared/network/ENUM__network_event_server_to_client';
import { add_socket_handler_client as add } from '../../_methods/add_socket_handler_client';

export function add_socket_handlers_client_workspace_ownership_proposal() {
  add(ENE.WORKSPACE_TRANSFER_OWNERSHIP_PROPOSAL_DELETE, (ids: string[]) => store.dispatch(local_workspace_transfer_ownership_proposal_delete(ids)));

  add(ENE.WORKSPACE_TRANSFER_OWNERSHIP_PROPOSAL_UPSERT, (items: DTOWorkspaceTranserOwnershipProposal[]) =>
    store.dispatch(local_workspace_transfer_ownership_proposal_upsert(items)),
  );
}
